import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Resolve, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UserService } from '../../shared/services/user/user.service';
import { ReplaySubject, Subscription } from 'rxjs';
import { switchMap, map, share, catchError } from 'rxjs/operators';
import jwt_decode from "jwt-decode";


@Injectable({
  providedIn: 'root'
})
export class TokenGuard implements CanActivate {
  private tokenVerified: boolean = false;
  constructor(
    private router: Router,
    private userService: UserService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
      this.userService.initUserInfo();
      if (localStorage.getItem('liquid_payout_portal_token_verified') == 'true'){
        console.log('tokenVerified=true');
        return of(true);
      } else {
        return this.userService.getUserDetails(jwt_decode(localStorage.getItem('liquid_payout_portal_id_token'))['email']).pipe(map(result => {
          localStorage.setItem('liquid_payout_portal_token_verified', 'true');
          console.log('tokenVerified=true');
          return true;
        }), catchError((err: any) => {
          this.router.navigateByUrl('/login');
          return of(false);
        }));
      }
  }
}
